import templateUrl from 'emun.customer/customer-query-criteria.htm'
import controller from 'servicestack/basic.controller'

let component = {
    bindings: {
        panelMaxHeight: '@',
        panelType: '@',
        query: '<'
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default component